<script setup>
import { ref, onMounted } from 'vue';
import _ from 'lodash';
import TransformImplementationFlow from './TransformImplementationFlow.vue';

const props = defineProps(['transform']);

let transform = ref(null);
let defaultTransform = ref('');

onMounted(() => {
    transform.value = props.transform;

    defaultTransform.value = _.cloneDeep(transform.value);
});
</script>

<template>
    <div v-if="transform?.id" class="mt-3 w-4/5 mx-auto">
        <TransformImplementationFlow :transform-id="transform?.id" />
    </div>
</template>

<style></style>
